/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { Credential11Proof } from './Credential11Proof';

export const Credential11: core.serialization.ObjectSchema<serializers.Credential11.Raw, Truvity.Credential11> =
    core.serialization.object({
        expirationDate: core.serialization.date().optional(),
        holder: core.serialization.string().optional(),
        id: core.serialization.string(),
        issuanceDate: core.serialization.date(),
        issuer: core.serialization.string(),
        proof: Credential11Proof,
        type: core.serialization.list(core.serialization.string()),
    });

export declare namespace Credential11 {
    export interface Raw {
        expirationDate?: string | null;
        holder?: string | null;
        id: string;
        issuanceDate: string;
        issuer: string;
        proof: Credential11Proof.Raw;
        type: string[];
    }
}
